// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAIAAADZF8uwAAAAGUlEQVQYV2M4gwH+YwCGIasIUwhT25BVBADtzYNYrHvv4gAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg width=%2720%27 height=%2720%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27m1 17 9-15 9 15H1ZM11 7v5H9V7h2Zm-1 8.1a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2Z%27 fill=%27%23000%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.svjs-highlight {
    z-index: 9999998;
    pointer-events: none !important;
    position: fixed;
    display: none;
}

.svjs-highlight-content {
    background: #6fa8dca8;
}

.svjs-highlight.show,
.svjs-popup.show {
    display: block;
}

.svjs-popup {
    color: #000;
    z-index: 9999999;
    position: fixed;
    display: none;
    background: #fff;
    max-width: min(260px, 100vw);
    font-family: monospace !important;
    padding: 0 .5rem 0;
    border-radius: 4px;
    pointer-events: none;
    box-shadow: rgba(99, 99, 99, 0.2) 1px 3px 3px 0px;
    max-height: min(320px, 100vh);
    overflow: auto;
    min-width: 250px;
}

.svjs-popup * {
    font-family: monospace !important;
    color: #000;
}

.svjs-popup *::selection {
    background: rgb(211 227 253);
    color: unset;
}

._css_viewer_info_width {
    font-weight: 100;
    font-size: 14px;
    color: #000;
    margin-left: 5px;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif !important;
}

._css_viewer_info_height {
    font-weight: 100;
    font-size: 14px;
    color: #000;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif !important;
}

._css_viewer_info_width::after {
    display: inline-block;
    content: '×';
    padding: 0 4px;
}

._css_viewer_info_element * {
    user-select: none !important;
}

._css_viewer_info_element_tag {
    font-weight: 100;
    font-size: 14px;
    font-family: 'Segoe UI', Tahoma, sans-serif !important;
    font-weight: 700;
    color: #881280;
}

._css_viewer_info_element_classname,
._css_viewer_info_element_id {
    font-weight: 100;
    font-size: 14px;
    font-family: 'Segoe UI', Tahoma, sans-serif !important;
    font-weight: 700;
    color: #1a1aa6;
}

._css_viewer_info_element_size {
    position: sticky;
    right: 0;
    margin: auto 0 auto auto;
    white-space: nowrap;
    width: fit-content;
    float: right;
    text-align: right;
}

._css_viewer_info_element_attribute {
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
    width: -webkit-fill-available;
}

._css_viewer_info_element {
    display: flex !important;
    white-space: nowrap;
    background: #fff;
    position: sticky;
    top: 0;
    padding: 0.5rem 0;
    border-width: 0 0 1px !important;
    margin: 0 0 0.375rem !important;
    z-index: 999;
}

.style-group+.style-group::before,
._css_viewer_info_element,
.svjs-style-content::after {
    border: solid #c7c7c7;
    border-width: 1px 0 0 0;
    margin: 6px 0;
    content: '';
    display: block;
}

.svjs-box {
    width: -webkit-fill-available;
    max-width: -webkit-fill-available;
    overflow: auto;
}

.svjs-box>.box {
    margin: 0 auto;
    width: fit-content;
}

.svjs-popup::-webkit-scrollbar,
.svjs-popup *::-webkit-scrollbar {
    width: 6px !important;
    height: 6px !important;
    border-radius: 0px !important;
    background: none !important;
}

.svjs-popup::-webkit-scrollbar-thumb,
.svjs-popup *::-webkit-scrollbar-thumb {
    background: rgba(171, 171, 171, 0.5) !important;
    min-height: 50px !important;
    min-width: 50px !important;
    border-radius: 10px !important;
    box-shadow: none !important;
}

.svjs-popup::-webkit-scrollbar-thumb:hover,
.svjs-popup *::-webkit-scrollbar-thumb:hover {
    background: rgba(171, 171, 171, 1) !important;
    min-height: 50px !important;
    min-width: 50px !important;
    border-radius: 10px !important;
    box-shadow: none !important;
}

.svjs-popup::-webkit-scrollbar-corner,
.svjs-popup *::-webkit-scrollbar-corner {
    background: none !important;
    box-shadow: none !important;
}

.svjs-popup::-webkit-scrollbar-track,
.svjs-popup *::-webkit-scrollbar-track {
    background: none !important;
}

._css_editor_info_stylesheets_content_styles_color {
    position: relative;
    margin-left: 2px;
    margin-right: 2px;
    width: 12px;
    height: 12px;
    transform: scale(0.8);
    vertical-align: -2px;
    display: inline-flex;
    user-select: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    line-height: 10px;
    box-sizing: border-box;
    padding: 0;
    align-items: center;
    justify-content: center;
}

._css_editor_info_stylesheets_content_styles_color_content {
    width: 11.9981px;
    height: 11.9981px;
    display: inline-block;
    border: 1px solid rgba(128, 128, 128, 0.6);
    box-sizing: border-box;
    cursor: pointer;
    background-color: rgb(24, 24, 24);
}

.svjs-style-content * {
    user-select: text;
}

.style-group {
    white-space: normal;
    overflow: hidden;
    word-wrap: break-word;
    word-break: break-all;
}

.style-origin {
    display: inline;
    overflow-wrap: break-word;
}

.style-origin a {
    text-decoration: underline;
}

.undefined-variable {
    color: rgb(175 170 170);
}

.style-value-url-link {
    color: #0068E0;
    text-decoration: underline;
}

.svjs-stylesheet-warn .svjs-stylesheet-key::before {
    content: '';
    display: inline-block;
    width: 14px;
    height: 14px;
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    mask-position: center center;
    mask-repeat: no-repeat;
    mask-size: 99%;
    background-color: rgb(232, 110, 48);
    display: inline-block;
    text-wrap: nowrap;
    position: relative;
    box-sizing: border-box;
    min-width: 0px;
    min-height: 0px;
    margin-right: 3px;
    margin-bottom: -3px;
}

.defined-variable {
    color: rgb(11, 87, 208);
    cursor: pointer;
}

.svjs-status {
    position: sticky;
    bottom: 0;
    padding: 8px 0;
    background: #fff;
    border: solid #c7c7c7;
    border-width: 1px 0 0 0;
    margin: 6px 0 0;
    content: '';
    display: block;
}

.svjs-popup * {
    pointer-events: none;
    user-select: none;
}

.svjs-popup.svjs-popup-control * {
    pointer-events: all;
    user-select: text;
}

.svjs-popup.svjs-popup-control {
    box-shadow: rgba(0, 0, 0, 0.2) 0px 4px 16px 0px;
    pointer-events: all;
}

.svjs-popup .box * {
    user-select: none !important;
}

.style-line-unsupported {
    text-decoration: line-through;
}

.svjs-stylesheet-value.style-line-unsupported * {
    color: #000;
}

.svjs-stylesheet {
    text-indent: 1rem;
    font-family: monospace;
}

.svjs-stylesheet.svjs-stylesheet-warn {
    text-indent: 0;
}

.svjs-stylesheet-key {
    color: #c80000;
}

.defined-variable:hover {
    text-decoration: underline;
}

[data-tippy-root] {
    z-index: 10000000 !important;
}`, "",{"version":3,"sources":["webpack://./src/StyleViewer.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,4BAA4B;IAC5B,iCAAiC;IACjC,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,iDAAiD;IACjD,6BAA6B;IAC7B,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,WAAW;AACf;;AAEA;IACI,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,2IAA2I;AAC/I;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,2IAA2I;AAC/I;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,sDAAsD;IACtD,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,gBAAgB;IAChB,eAAe;IACf,sDAAsD;IACtD,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,QAAQ;IACR,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;IACvB,OAAO;IACP,6BAA6B;AACjC;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,MAAM;IACN,iBAAiB;IACjB,gCAAgC;IAChC,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;;;IAGI,qBAAqB;IACrB,uBAAuB;IACvB,aAAa;IACb,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,iCAAiC;IACjC,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;;IAEI,qBAAqB;IACrB,sBAAsB;IACtB,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA;;IAEI,+CAA+C;IAC/C,2BAA2B;IAC3B,0BAA0B;IAC1B,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;;IAEI,6CAA6C;IAC7C,2BAA2B;IAC3B,0BAA0B;IAC1B,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;;IAEI,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,oBAAoB;IACpB,oBAAoB;IACpB,iBAAiB;IACjB,yDAA6J;IAC7J,iBAAiB;IACjB,sBAAsB;IACtB,UAAU;IACV,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,0CAA0C;IAC1C,sBAAsB;IACtB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,mDAAqT;IACrT,4BAA4B;IAC5B,sBAAsB;IACtB,cAAc;IACd,mCAAmC;IACnC,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,+CAA+C;IAC/C,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;AAChC","sourcesContent":[".svjs-highlight {\n    z-index: 9999998;\n    pointer-events: none !important;\n    position: fixed;\n    display: none;\n}\n\n.svjs-highlight-content {\n    background: #6fa8dca8;\n}\n\n.svjs-highlight.show,\n.svjs-popup.show {\n    display: block;\n}\n\n.svjs-popup {\n    color: #000;\n    z-index: 9999999;\n    position: fixed;\n    display: none;\n    background: #fff;\n    max-width: min(260px, 100vw);\n    font-family: monospace !important;\n    padding: 0 .5rem 0;\n    border-radius: 4px;\n    pointer-events: none;\n    box-shadow: rgba(99, 99, 99, 0.2) 1px 3px 3px 0px;\n    max-height: min(320px, 100vh);\n    overflow: auto;\n    min-width: 250px;\n}\n\n.svjs-popup * {\n    font-family: monospace !important;\n    color: #000;\n}\n\n.svjs-popup *::selection {\n    background: rgb(211 227 253);\n    color: unset;\n}\n\n._css_viewer_info_width {\n    font-weight: 100;\n    font-size: 14px;\n    color: #000;\n    margin-left: 5px;\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif !important;\n}\n\n._css_viewer_info_height {\n    font-weight: 100;\n    font-size: 14px;\n    color: #000;\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif !important;\n}\n\n._css_viewer_info_width::after {\n    display: inline-block;\n    content: '×';\n    padding: 0 4px;\n}\n\n._css_viewer_info_element * {\n    user-select: none !important;\n}\n\n._css_viewer_info_element_tag {\n    font-weight: 100;\n    font-size: 14px;\n    font-family: 'Segoe UI', Tahoma, sans-serif !important;\n    font-weight: 700;\n    color: #881280;\n}\n\n._css_viewer_info_element_classname,\n._css_viewer_info_element_id {\n    font-weight: 100;\n    font-size: 14px;\n    font-family: 'Segoe UI', Tahoma, sans-serif !important;\n    font-weight: 700;\n    color: #1a1aa6;\n}\n\n._css_viewer_info_element_size {\n    position: sticky;\n    right: 0;\n    margin: auto 0 auto auto;\n    white-space: nowrap;\n    width: fit-content;\n    float: right;\n    text-align: right;\n}\n\n._css_viewer_info_element_attribute {\n    word-break: break-all;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    flex: 1;\n    width: -webkit-fill-available;\n}\n\n._css_viewer_info_element {\n    display: flex !important;\n    white-space: nowrap;\n    background: #fff;\n    position: sticky;\n    top: 0;\n    padding: 0.5rem 0;\n    border-width: 0 0 1px !important;\n    margin: 0 0 0.375rem !important;\n    z-index: 999;\n}\n\n.style-group+.style-group::before,\n._css_viewer_info_element,\n.svjs-style-content::after {\n    border: solid #c7c7c7;\n    border-width: 1px 0 0 0;\n    margin: 6px 0;\n    content: '';\n    display: block;\n}\n\n.svjs-box {\n    width: -webkit-fill-available;\n    max-width: -webkit-fill-available;\n    overflow: auto;\n}\n\n.svjs-box>.box {\n    margin: 0 auto;\n    width: fit-content;\n}\n\n.svjs-popup::-webkit-scrollbar,\n.svjs-popup *::-webkit-scrollbar {\n    width: 6px !important;\n    height: 6px !important;\n    border-radius: 0px !important;\n    background: none !important;\n}\n\n.svjs-popup::-webkit-scrollbar-thumb,\n.svjs-popup *::-webkit-scrollbar-thumb {\n    background: rgba(171, 171, 171, 0.5) !important;\n    min-height: 50px !important;\n    min-width: 50px !important;\n    border-radius: 10px !important;\n    box-shadow: none !important;\n}\n\n.svjs-popup::-webkit-scrollbar-thumb:hover,\n.svjs-popup *::-webkit-scrollbar-thumb:hover {\n    background: rgba(171, 171, 171, 1) !important;\n    min-height: 50px !important;\n    min-width: 50px !important;\n    border-radius: 10px !important;\n    box-shadow: none !important;\n}\n\n.svjs-popup::-webkit-scrollbar-corner,\n.svjs-popup *::-webkit-scrollbar-corner {\n    background: none !important;\n    box-shadow: none !important;\n}\n\n.svjs-popup::-webkit-scrollbar-track,\n.svjs-popup *::-webkit-scrollbar-track {\n    background: none !important;\n}\n\n._css_editor_info_stylesheets_content_styles_color {\n    position: relative;\n    margin-left: 2px;\n    margin-right: 2px;\n    width: 12px;\n    height: 12px;\n    transform: scale(0.8);\n    vertical-align: -2px;\n    display: inline-flex;\n    user-select: none;\n    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAIAAADZF8uwAAAAGUlEQVQYV2M4gwH+YwCGIasIUwhT25BVBADtzYNYrHvv4gAAAABJRU5ErkJggg==);\n    line-height: 10px;\n    box-sizing: border-box;\n    padding: 0;\n    align-items: center;\n    justify-content: center;\n}\n\n._css_editor_info_stylesheets_content_styles_color_content {\n    width: 11.9981px;\n    height: 11.9981px;\n    display: inline-block;\n    border: 1px solid rgba(128, 128, 128, 0.6);\n    box-sizing: border-box;\n    cursor: pointer;\n    background-color: rgb(24, 24, 24);\n}\n\n.svjs-style-content * {\n    user-select: text;\n}\n\n.style-group {\n    white-space: normal;\n    overflow: hidden;\n    word-wrap: break-word;\n    word-break: break-all;\n}\n\n.style-origin {\n    display: inline;\n    overflow-wrap: break-word;\n}\n\n.style-origin a {\n    text-decoration: underline;\n}\n\n.undefined-variable {\n    color: rgb(175 170 170);\n}\n\n.style-value-url-link {\n    color: #0068E0;\n    text-decoration: underline;\n}\n\n.svjs-stylesheet-warn .svjs-stylesheet-key::before {\n    content: '';\n    display: inline-block;\n    width: 14px;\n    height: 14px;\n    mask-image: url(\"data:image/svg+xml,%3Csvg width=%2720%27 height=%2720%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27m1 17 9-15 9 15H1ZM11 7v5H9V7h2Zm-1 8.1a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2Z%27 fill=%27%23000%27/%3E%3C/svg%3E\");\n    mask-position: center center;\n    mask-repeat: no-repeat;\n    mask-size: 99%;\n    background-color: rgb(232, 110, 48);\n    display: inline-block;\n    text-wrap: nowrap;\n    position: relative;\n    box-sizing: border-box;\n    min-width: 0px;\n    min-height: 0px;\n    margin-right: 3px;\n    margin-bottom: -3px;\n}\n\n.defined-variable {\n    color: rgb(11, 87, 208);\n    cursor: pointer;\n}\n\n.svjs-status {\n    position: sticky;\n    bottom: 0;\n    padding: 8px 0;\n    background: #fff;\n    border: solid #c7c7c7;\n    border-width: 1px 0 0 0;\n    margin: 6px 0 0;\n    content: '';\n    display: block;\n}\n\n.svjs-popup * {\n    pointer-events: none;\n    user-select: none;\n}\n\n.svjs-popup.svjs-popup-control * {\n    pointer-events: all;\n    user-select: text;\n}\n\n.svjs-popup.svjs-popup-control {\n    box-shadow: rgba(0, 0, 0, 0.2) 0px 4px 16px 0px;\n    pointer-events: all;\n}\n\n.svjs-popup .box * {\n    user-select: none !important;\n}\n\n.style-line-unsupported {\n    text-decoration: line-through;\n}\n\n.svjs-stylesheet-value.style-line-unsupported * {\n    color: #000;\n}\n\n.svjs-stylesheet {\n    text-indent: 1rem;\n    font-family: monospace;\n}\n\n.svjs-stylesheet.svjs-stylesheet-warn {\n    text-indent: 0;\n}\n\n.svjs-stylesheet-key {\n    color: #c80000;\n}\n\n.defined-variable:hover {\n    text-decoration: underline;\n}\n\n[data-tippy-root] {\n    z-index: 10000000 !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
